import { Answer } from '@/models/Answer';
import { Report } from '@/models/Report';
import { Question as QuestionModel } from '@/models/Question';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Question from '@/components/Questionnaire/Question.vue';

@Component<Questionnaire>({
  components: {
    Question,
  },
})
export default class Questionnaire extends Vue {
  @Prop({ default: false })
  protected disabled!: boolean;

  @Prop()
  protected questions!: QuestionModel[];

  @Prop()
  protected answers!: Answer[] | {[key: string]: string};

  @Prop()
  protected report!: Report;

  @Prop()
  protected emitOnChange!: boolean;

  @Emit()
  protected besluitBestuurUpdated(value: string): string {
    return value;
  }

  @Emit()
  protected overwriteAssignmentValue(): string {
    return '';
  }

  @Emit()
  protected emitAnswerPayload(payload: Record<string, string>): Record<string, string> {
    return payload;
  }
}
